import React from 'react';

import styles from './styles.module.css';

interface Props {
  text: string;
}

export const Title = ({ text }: Props) => {
  return <div className={styles.heading}>{text}</div>;
};

export const SubtitleCategory = ({ text }: Props) => {
  return (
    <div className={styles.category}>
      <h2 className={styles.text}>
        <span className={styles.wrap}>{text}</span>
      </h2>
    </div>
  );
};
